import { useSelector } from 'react-redux';

export default function usePaymentOptions() {
  const paymentOptions = useSelector(
    (state) => state.storeGroup.paymentOptions
  );

  return paymentOptions;
}
